import {MeasurementStatus} from "../../found-measurement";
import {ALL_ECG_MEASUREMENT_TYPES, MeasurementType} from "../../../measurement-models";
import {EcgWorkflow} from "../../../hospitals/edit-hospital/hospital.details";

export interface AssignableDoctorTypeData {
  type: MeasurementType;
  status: MeasurementStatus;
  assignSleepTechniciansEnabled: boolean | undefined;
  ecgWorkflow: EcgWorkflow | undefined;
}

type AssignableDoctorType = "DOCTOR" | "TECHNICIAN" | "NONE";

export interface TechnicianAssignableData {
  type: MeasurementType;
  status: MeasurementStatus;
  assignSleepTechniciansEnabled: boolean | undefined;
  ecgWorkflow: EcgWorkflow;
}

export function whichDoctorTypeIsAssignable(data: AssignableDoctorTypeData): AssignableDoctorType {

  const technicianShouldPreanalyze = data.assignSleepTechniciansEnabled! && data.type === "SLEEP"
    || data.ecgWorkflow === "TECHNICIAN_PRE_ANALYSIS" && ALL_ECG_MEASUREMENT_TYPES.includes(data.type);

  if (data.status === "UPLOADED" && technicianShouldPreanalyze) {
    return "TECHNICIAN";
  }

  if (
    data.status === "PRE_ANALYSED"
    || data.status === "UPLOADED" && !technicianShouldPreanalyze
  ) {
    return "DOCTOR";
  }

  return "NONE";
}
